/**
 * AllMail created by johnmc on 05/11/17.
 */
import {Component, Input, OnInit} from '@angular/core';

import {AppComponent} from '../app.component';

@Component({
  selector: 'all-stock',
  template: '<stock-sub-menu></stock-sub-menu><stock-list></stock-list>',
  styles: [],
})

export class AllStockComponent implements OnInit {
  @Input()
  errorMessage: string;

  constructor() { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    document.getElementById('title').innerText = 'All Stock';
  }

}
